import { toASCII } from "punycode";

const address = new URL(location.href);
const siteName = (
    document.querySelector('meta[property="og:site_name"]') as HTMLMetaElement
)?.content;

if (_REMOTE_URL?.endsWith("/")) {
    _REMOTE_URL = _REMOTE_URL!.substring(0, -1);
}

export const host = _HOST || address.host;
export const hostname = address.hostname;
export const url = _REMOTE_URL || address.origin;
export const apiUrl = `${url}/api`;
export const magStreamingUrl = `${url}/mag/v1`;
export const feApiUrl = `${url}/fe-api`;
export const lang = localStorage.getItem("lang");
export const locale = localStorage.getItem("locale");
export const langs = _LANGS_;
export const version = _VERSION_;
export const env = structuredClone(_ENV_);
export const debug = env["NODE_ENV"] !== "production";
export const instanceName = siteName === "Magnetar" ? "" + host : siteName;

export function resolveHost(h: string | null): string | null {
    if (!h) {
        return null;
    }

    if (toASCII(h) === toASCII(host)) {
        return null;
    }

    return h;
}
